module.exports = __webpack_public_path__ + "img/pr-4.00d275b3.png";